<template>
  <a
    target="_blank"
    referrerpolicy="no-referrer"
    :href="href"
    rel="no-referrer"
    class="review_banner d-flex-row space-between gap-9"
    :class="[type]"
    style="height: max-content"
  >
    <div
      class="d-flex-row flex-3 gap-2"
      v-if="type === 'reviewio'"
      style="height: max-content"
    >
      <ReviewIoStar
        v-for="i in [1, 2, 3, 4, 5]"
        :key="i"
        style="height: 16px; width: 16px"
      />
    </div>
    <div class="d-flex-row flex-3 gap-2" v-if="type === 'trustpilot'">
      <TrustpilotStar
        v-for="i in [1, 2, 3, 4, 5]"
        :key="i"
        style="height: 16px; width: 17px"
      />
    </div>
    <p class="font-family-2 bold-m">
      {{ reviews }}+<span class="medium-m">
        {{ $t("missed.reviews_on") }}</span
      >
    </p>

    <img
      :src="`/images/review_io_mini.webp`"
      width="18"
      height="18"
      class="small"
      alt="Review.io logo"
    />
    <p class="font-family-2 bold-m above-md-hide">
      <span class="medium-m">&</span>
    </p>
    <img
      :src="`/images/trustpilot_mini.webp`"
      width="18"
      height="18"
      class="small"
      alt="Trustpilot logo"
    />
  </a>
</template>

<script setup>
import ReviewIoStar from "../icons/socials/ReviewIoStar.vue";
import TrustpilotStar from "../icons/socials/TrustpilotStar.vue";
import { computed } from "vue";

const { type, reviews } = defineProps({
  type: {
    type: String,
    default: "",
  },
  reviews: {
    type: Number,
    default: 0,
  },
});

const href = computed(() => {
  return "https://www.trustpilot.com/review/boostingmarket.com";
});
</script>
